import func from '@/utils/func';
import axios from 'axios'
import {generateSHA256Sign,generateNonce} from '@/utils/index';

/**
 * 封装axios，实现发送/响应接口的拦截，来实现统一提示等效果
 */

var service = axios.create({
  // baseURL: 'http://fcbrand.local.com/',
  baseURL: func.getApiBaseURL(),
  timeout:30000, // 请求超时时间限制
  headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',brand:func.getBrandId(),token:func.getLocal('token')},
  transformRequest: [function (data) {
    let ret = ''
    for (let it in data) {
      ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    }
    return ret
  }],
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // func.startLoading()
    config.headers.brand = func.getBrandId();
    if (Object.prototype.hasOwnProperty.call(config.headers, 'scanToken')) {
      config.headers.token = `${config.headers.scanToken || ''}`;
      delete config.headers.scanToken;
    } else {
      config.headers.token = `${func.getLocal('token') || ''}`;
    }
    if(!config.headers.sign) {
      let data = config.data || config.params;
      const params = {
          timestamp: Date.now(),
          nonce: generateNonce(),
      };
      if (typeof(data) !== 'undefined') {
          for (let key in data) {
              params[key] = data[key];
          }
      }
      config.headers.timestamp = params.timestamp;
      config.headers.nonce = params.nonce;
      config.headers.sign = generateSHA256Sign(params);
    }
    return config
  },
  err => {
    // func.endLoading()
    func.showToast()
    Promise.reject(err)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    // func.endLoading()
    console.log(response);
    if(response.status == 200){
      if(!response.data.code || response.data.code == 2){
        return response.data
      }else{
        if(response.config && response.config.silentError){
          return response.data
        }
        // func.endLoading();
        func.showToast(response.data.msg);
        return false;
      }
    }else{
      func.showToast('服务器跑丢了')
    }
  },
  err => {
    if(!(err.config && err.config.silentError)) func.showToast();
    return Promise.reject(err)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js